import './ViewAccessDetailsComponent.scss';
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import {ImageConfig, Misc} from "../../../../constants";
import {CommonService} from "../../../../shared/services";
import React, {useCallback, useState} from "react";
import ProfileFoundCardComponent from "../../../../shared/components/profile-found-card/ProfileFoundCardComponent";
import moment from "moment";
import LottieFileGenarationComponent
    from "../../../../shared/components/lottie-file-genaration/LottieFileGenarationComponent";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";
import {IAPIResponseType} from "../../../../shared/models/api.model";

interface ViewAccessDetailsProps {
    getRequestAccessDetailsData: any;
    currentUser: any;
    handleEditRequestAccessDetails: any;
    handleOpenWithdrawModal: any;
    currentTab?: any;
    closeDrawer?: any;
}

const ViewAccessDetailsComponent = (props: ViewAccessDetailsProps) => {
    const {
        getRequestAccessDetailsData,
        currentUser,
        handleEditRequestAccessDetails,
        currentTab,
        closeDrawer

    } = props;
    const [openWithdrawModal, setOpenWithdrawModal] = useState<boolean>(false);
    const [isRequestIsLoading, setIsRequestIsLoading] = useState<boolean>(false);


    const handleOpenWithdrawModal = useCallback(() => {
        setOpenWithdrawModal(true)
    }, []);

    const closeWithdrawModal = useCallback(() => {
        setOpenWithdrawModal(false);
    }, []);

    const handleWithdrawRequest = useCallback(() => {
        setIsRequestIsLoading(true);
        CommonService._client.cancelRequestedAccess(getRequestAccessDetailsData?._id, {})
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setOpenWithdrawModal(false);
                setIsRequestIsLoading(false);
                closeDrawer();
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: currentTab
                });
            }).catch((error: any) => {
            setOpenWithdrawModal(false);
            setIsRequestIsLoading(false);
            CommonService._alert.showToast(error.message, "error");
        })
    }, [getRequestAccessDetailsData,closeDrawer, currentTab]);

    return (
        <div className={'view-access-details'}>
            <div className={'view-access-details-container'}>
                <div className={'from-request-to'}>From:</div>
                <div className={'view-access-details-profile-card'}>
                    <ProfileFoundCardComponent profileDetails={currentUser}/>
                </div>
                <div className={'from-request-to mrg-top-25'}>{getRequestAccessDetailsData?.request_type ==="grant_access" ? 'Request Granted To (Approver):' : 'Request Sent To (Approver):'}</div>

                <div className={"view-account-details-wrapper"}>
                    <div className="profile-card-wrapper">
                        <ProfileFoundCardComponent profileDetails={getRequestAccessDetailsData?.approver_details}/>
                    </div>

                    <div className={'permissions-content'}>
                        <div className={'permissions-content-wrapper'}>
                            <div className={'relationship--permission-heading'}>Date of Birth:</div>
                            <div className={'relationship--permission-content'}>
                                {moment(getRequestAccessDetailsData?.approver_details?.dob).format('DD-MMM-YYYY') || 'N/A'}
                            </div>
                        </div>
                        <div className={'permissions-content-wrapper'}>
                            <div className={'relationship--permission-heading'}>Relationship:</div>
                            <div className={'relationship--permission-content'}>
                                {CommonService.capitalizeFirstLetter(getRequestAccessDetailsData?.relationship) || 'N/A'}
                            </div>
                        </div>
                        <div className={'permissions-content-wrapper'}>
                            <div className={'relationship--permission-heading'}>Permissions:</div>
                            <div className={'relationship--permission-content'}>
                                {getRequestAccessDetailsData?.permission_type === 'non_mutual' ? 'One-Way Access' : 'Mutual Access'}
                                {getRequestAccessDetailsData?.permission_type === 'non_mutual' &&
                                    <ul className={'mrg-top-5 mrg-left-20'}>
                                        <li className={'mrg-bottom-10 mrg-top-10'}><b>You</b> have access to the
                                            approver's account to book appointments and manage their account.
                                        </li>
                                        <li className={'mrg-bottom-10'}>The <b> approver</b> does not have permission to
                                            access your account.
                                        </li>
                                        <li>This access can be changed at any time.</li>
                                    </ul>}
                                {
                                    getRequestAccessDetailsData?.permission_type === 'mutual' &&
                                    <ul className={'mrg-top-5 mrg-left-20'}>
                                        <li className={'mrg-bottom-10 mrg-top-10'}>
                                            Gives the <b>approver</b> access to your account to book
                                            appointments and manage your account on your behalf.
                                        </li>
                                        <li className={'mrg-bottom-10'}>
                                            Gives <b>you</b> access to the approver's account to book appointments and
                                            manage their account.
                                        </li>
                                        <li>This access can be changed at any time.</li>
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'footer-container'}>
                <ButtonComponent onClick={handleOpenWithdrawModal}
                                 variant={'outlined'} color={'accent'}>Withdraw Access</ButtonComponent>

                {currentUser?.current_user_id === getRequestAccessDetailsData?.requested_by
                    && <ButtonComponent prefixIcon={<ImageConfig.EditIcon/>}
                                        onClick={() => handleEditRequestAccessDetails(getRequestAccessDetailsData, getRequestAccessDetailsData?.approver_details?.client_id, 'edit')}
                                        color={'accent'}
                                        className={'mrg-left-20'}
                    >Edit Access</ButtonComponent>}
            </div>

            <ModalComponent
                isOpen={openWithdrawModal}
                onClose={closeWithdrawModal}
            >
                <div className="modal__content">
                    <div className={'confirm-popup-component width-350'}>
                        <div className={'confirm-popup-image'}>
                            <LottieFileGenarationComponent
                                loop={true}
                                autoplay={true}
                                animationData={ImageConfig.BlueConfirmationLottie}/>
                        </div>
                        <div className="confirm-popup-meta">
                            <div className={'confirm-popup-description font-size-18 d-inline-block'}>
                                Are you sure you want to withdraw the access <br/>
                                request sent to <b
                                className="text-color-primary"> {getRequestAccessDetailsData?.approver_details?.first_name} {getRequestAccessDetailsData?.approver_details?.last_name} </b>?
                            </div>

                            <div className={'confirm-popup-continue-and-cancel-cta pdd-top-15'}>
                                <ButtonComponent
                                    className="mrg-right-10"
                                    variant={"outlined"}
                                    fullWidth={true}
                                    color={"default"}
                                    onClick={closeWithdrawModal}>No</ButtonComponent>
                                <ButtonComponent
                                    className="mrg-left-10"
                                    fullWidth={true}
                                    isLoading={isRequestIsLoading}
                                    color={"accent"}
                                    onClick={() => {
                                        handleWithdrawRequest();
                                    }}
                                >Yes</ButtonComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>

        </div>
    )
}
export default ViewAccessDetailsComponent;
